export const HEADER_HEIGHT = 64;
export const DRAWER_WIDTH = 265;
export const DRAWER_MINI_WIDTH = 70;
export const PADDING_CONTENT = 5;
